import {Component} from 'react'
import Loader from 'react-loader-spinner'

import LanguageFiltersItem from '../LanguageFilterItem'
import RepositoryItem from '../RepositoryItem'

import './index.css'

const languageFiltersData = [
  {id: 'ALL', language: 'All'},
  {id: 'JAVASCRIPT', language: 'Javascript'},
  {id: 'RUBY', language: 'Ruby'},
  {id: 'JAVA', language: 'Java'},
  {id: 'CSS', language: 'CSS'},
]

const apiStatusConstants = {
  initial: 'INITIAL',
  inProgress: 'IN_PROGRESS',
  success: 'SUCCESS',
  failure: 'FAILURE',
}

class GithubPopularRepos extends Component {
  state = {
    apiStatus: apiStatusConstants.initial,
    activeId: 'ALL',
    repoList: [],
  }

  componentDidMount() {
    this.getRepodata()
  }

  getRepodata = async () => {
    const {activeId} = this.state
    this.setState({apiStatus: apiStatusConstants.inProgress})

    const url = `https://apis.ccbp.in/popular-repos?language=${activeId}`

    try {
      const response = await fetch(url)
      if (response.ok) {
        const data = await response.json()
        const updatedData = data.popular_repos.map(each => ({
          id: each.id,
          name: each.name,
          issuesCount: each.issues_count,
          forksCount: each.forks_count,
          starsCount: each.stars_count,
          avatarUrl: each.avatar_url,
        }))
        this.setState({
          repoList: updatedData,
          apiStatus: apiStatusConstants.success,
        })
      } else {
        this.setState({apiStatus: apiStatusConstants.failure})
      }
    } catch (e) {
      this.setState({apiStatus: apiStatusConstants.failure})
    }
  }

  onClickTab = tabId => {
    this.setState({activeId: tabId}, this.getRepodata)
  }

  renderRepos = () => {
    const {repoList} = this.state
    return (
      <ul className="repo-list">
        {repoList.map(repo => (
          <RepositoryItem key={repo.id} details={repo} />
        ))}
      </ul>
    )
  }

  renderLoader = () => (
    <div data-testid="loader" className="loader-container">
      <Loader type="ThreeDots" color="#0284c7" height={80} width={80} />
    </div>
  )

  renderFailure = () => (
    <div className="failure-view">
      <img
        src="https://assets.ccbp.in/frontend/react-js/api-failure-view.png"
        alt="failure view"
        className="failure-img"
      />
      <h2 className="failure-text">Something Went Wrong</h2>
    </div>
  )

  renderResult = () => {
    const {apiStatus} = this.state

    switch (apiStatus) {
      case apiStatusConstants.success:
        return this.renderRepos()
      case apiStatusConstants.failure:
        return this.renderFailure()
      case apiStatusConstants.inProgress:
        return this.renderLoader()
      default:
        return null
    }
  }

  render() {
    const {activeId} = this.state

    return (
      <div className="main-container">
        <h1 className="main-heading">Popular</h1>
        <ul className="language-container">
          {languageFiltersData.map(each => (
            <LanguageFiltersItem
              key={each.id}
              details={each}
              onClickTab={this.onClickTab}
              isActive={activeId === each.id}
            />
          ))}
        </ul>
        {this.renderResult()}
      </div>
    )
  }
}

export default GithubPopularRepos
